import styled from 'styled-components';

import {commonPalette} from 'styles/palette';
import {darken} from 'utils/color-utils';

export const getContentStyles = () => ({
  border: 0,
  borderRadius: 4,
  top: 'auto',
  boxShadow: [
    '0 24px 38px rgba(0, 0, 0, 0.14)',
    '0 9px 46px rgba(0, 0, 0, 0.12)',
    '0 11px 15px rgba(0, 0, 0, 0.2)'
  ].join(),
  display: 'flex',
  flexDirection: 'column',
  left: '50%',
  padding: 24,
  position: 'fixed',
  right: 'auto',
  bottom: '0px',
  transform: 'translate(-50%, -50%)',
  overflow: 'none',
  width: '90%',
  maxWidth: '720px'
});

export const getOverlayStyles = () => ({
  backgroundColor: 'none',
  height: 0,
  width: 0
});

export const StyledLink = styled.a`
  color: inherit;
  font-weigth: 600;
  text-decoration: underline;
  text-underline-offset: 3px;

  &:hover {
    color: ${commonPalette.txBlack};
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
`;

export const TopSection = styled.div`
  width: ${({isMobile}) => (isMobile ? '100' : '85')}%;
  ${({isMobile}) => (isMobile ? 'margin-bottom: 10px;' : '')}
`;

export const BottomSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const StyledButton = styled.a`
  color: ${commonPalette.white};
  background: ${({disabled}) => (disabled ? commonPalette.lightGreen : commonPalette.sgGreen)};
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  min-width: 92.75px;
  min-height: 40px;
  display: inline-block;
  position: relative;

  &:hover {
    color: ${commonPalette.white};
    background: ${({disabled}) => (disabled ? commonPalette.lightGreen : darken(commonPalette.sgGreen, 0.15))};
  }

  &:link {
    text-decoration: none;
  }
`;
